import { render, staticRenderFns } from "./ViParentReview.vue?vue&type=template&id=471fbba4&scoped=true"
import script from "./ViParentReview.vue?vue&type=script&lang=js"
export * from "./ViParentReview.vue?vue&type=script&lang=js"
import style0 from "./ViParentReview.vue?vue&type=style&index=0&id=471fbba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471fbba4",
  null
  
)

export default component.exports